import React from 'react';
import history from 'app/routes/history';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Flatpickr from 'react-flatpickr';
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import moment from 'moment';
import _ from 'lodash';
import SectionGroup from 'app/components/general/SectionGroup';

import InputGroupBlock from 'app/components/general/InputGroupBlock';
import Button from 'app/components/general/Button';
import HeaderThin from 'app/components/layout/HeaderThin';

import * as reportsActions from 'app/ducks/reports/actions';
import { convertToUtc } from 'app/utils/parsers';

import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as reportsSelectors from 'app/ducks/reports/selectors';
import * as organisationSelectors from 'app/ducks/organisations/selectors';

import timezones from 'app/utils/static/timezones';

function selector(state) {
  return {
    organisations: organisationSelectors.getOrganisations(state),
    reports: reportsSelectors.getReports(state),
    appReady: loadingSelectors.appReady(state),
  };
}

const actionCreators = _.merge(
  reportsActions,
);

interface IOverdueMatchpaymentsReportProps {
  appReady: boolean;
  actions: any;
  reports: any;
  organisations: any;
  isLoading: boolean;
}
interface IOverdueMatchpaymentsReportState {
  errors: any;
  changed: boolean;
}

@connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
}))
export default class OverdueMatchpaymentsReport extends React.Component<IOverdueMatchpaymentsReportProps, IOverdueMatchpaymentsReportState> {
  static defaultProps: IOverdueMatchpaymentsReportProps = {
    appReady: false,
    actions: undefined,
    reports: undefined,
    isLoading: false,
  };

  state: IOverdueMatchpaymentsReportState = {
    changed: false,
    errors: {},
  };


  handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
    };
    this.props.actions.createOverdueMatchPaymentsReport(payload);
    this.setState({ changed: false });
  };

  renderBackendErrors = (): React.ReactNode => {
    if (this.props.reports.backendErrors !== undefined && !_.isEmpty(this.props.reports.backendErrors)) {
      return (
        <span className="backend-errors">
          {this.props.reports.backendErrors}
        </span>
      );
    }
    return null;
  };

  render(): React.ReactNode {
    return (
      <div>
        <div className="row">
          <div className="col">
            <HeaderThin
              breadcrumb="Reports"
              breadcrumbLink="/reports"
              title="Overdue Match Payments Report"
            />
          </div>
        </div>
        <div className="row">
          <div className="col col-12 col-lg-8 col-xlg-6">
            <SectionGroup title="Report Options">
              <div className="row">
                <div className="col">
                  No report options required.
                </div>
              </div>
              <div className="row">
                <div className="col btn-flex-group less-padding">
                  {this.renderBackendErrors()}
                  <div className="btn-flex-container">
                    <Button
                      className="btn-standard btn-1"
                      isLoading={this.props.reports.isLoading}
                      type="submit"
                      onClick={this.handleSubmit}
                    >
                      Download Report
                    </Button>
                    <Button
                      onClick={() => history.push('/reports')}
                      className="btn-standard btn-2"
                    >
                      Back
                    </Button>
                  </div>
                </div>
              </div>
            </SectionGroup>
          </div>
        </div>
      </div>
    );
  }
}
